
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/document/policy",
      function () {
        return require("private-next-pages/document/policy.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/document/policy"])
      });
    }
  